export const generateId = () => {
  return `${+new Date()}-${Math.random().toString(36).substr(2, 9)}`
}
export const generateValidId = () => {
  return `${+new Date()}-1-${Math.random().toString(36).substr(2, 9)}`
}
export const generateNotValidId = () => {
  return `${+new Date()}-0-${Math.random().toString(36).substr(2, 9)}`
}

export const isValid = (id) => {
  const timestamp = parseInt(id.split("-")[0], 10)
  const isTest = Number(id.split("-")[1]) === 1 ? "berhasil" : "gagal"
  const oneHourInMilliseconds = 60 * 60 * 1000
  const currentTime = Date.now()

  return currentTime - timestamp <= oneHourInMilliseconds
}

export const checkUserValidity = (id) => {
  // Initial validation for null or undefined id
  if (!id) {
    // console.log("Invalid ID: ID is missing.")
    return { isValid: false, isSuccess: null, isHaveCheckButaWarna: false }
  }

  // Split the id into parts
  const parts = id.split("-")
  // Ensure we have the correct number of parts
  if (parts.length < 3) {
    // console.log("Invalid ID format: ID does not contain the expected parts.")
    return { isValid: false, isSuccess: null, isHaveCheckButaWarna: false }
  }

  // Parse the timestamp and validate
  const timestamp = parseInt(parts[0], 10)
  if (isNaN(timestamp)) {
    // console.log("Invalid ID: Timestamp is not a number.")
    return { isValid: false, isSuccess: null, isHaveCheckButaWarna: false }
  }

  // Determine the success status
  const status = parts[1]
  const isSuccess = status === "1" ? "berhasil" : "gagal"

  // Calculate the time difference to check validity
  const oneHourInMilliseconds = 60 * 60 * 1000
  const currentTime = Date.now()
  const timeDifference = currentTime - timestamp
  const isValid = timeDifference <= oneHourInMilliseconds

  // Debugging information
  // console.log({
  //   id,
  //   timestamp,
  //   status,
  //   isValid,
  //   isSuccess,
  //   currentTime,
  //   timeDifference,
  // })

  // Return the result
  return { isValid, isSuccess, isHaveCheckButaWarna: true }
}
